'use strict';

exports.__esModule = true;

var _reactRouter = require('react-router');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _reactRouter.Prompt;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/Prompt.js
// module id = 797
// module chunks = 0